jQuery(document).ready(function ($) {
    let postSwiper;
    function initpostSwiper() {
        postSwiper = new Swiper(".post-slider", {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
            wrapperClass: "swiper-wrapper",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
            autoplay: {
                delay: 6000,
            },
        });
    }

    $(".post-slider").imagesLoaded(function () {
        initpostSwiper();
    });
});
